import { render, staticRenderFns } from "./BenchmarkGroupTable.vue?vue&type=template&id=7aa583a8&scoped=true&"
import script from "./BenchmarkGroupTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./BenchmarkGroupTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BenchmarkGroupTable.vue?vue&type=style&index=0&id=7aa583a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa583a8",
  null
  
)

export default component.exports